import { useState, useEffect } from "react";

async function fetchRange(url, start, end) {
    const res = await fetch(url, {
        headers: { Range: `bytes=${start}-${end}` }
    });

    if (res.status !== 206) {
        throw new Error("Server did not return partial content");
    }

    return new Uint8Array(await res.arrayBuffer());
}

function parseID3v2Comment(bytes) {
    // ID3v2 header is 10 bytes: "ID3" + version (2 bytes) + flags (1 byte) + size (4 bytes)
    if (bytes[0] !== 0x49 || bytes[1] !== 0x44 || bytes[2] !== 0x33) {
        return null;
    }

    const tagSize =
        (bytes[6] << 21) |
        (bytes[7] << 14) |
        (bytes[8] << 7) |
        bytes[9];

    const tag = bytes.slice(10, 10 + tagSize);

    let pos = 0;
    const decoder = new TextDecoder("latin1"); // default encoding for ID3v2.3 comments

    while (pos + 10 <= tag.length) {
        const id = decoder.decode(tag.slice(pos, pos + 4));
        const frameSize =
            (tag[pos + 4] << 24) |
            (tag[pos + 5] << 16) |
            (tag[pos + 6] << 8) |
            tag[pos + 7];

        if (frameSize <= 0) break;

        if (id === "COMM") {
            const frame = tag.slice(pos + 10, pos + 10 + frameSize);

            let offset = 4;

            // Skip short description
            while (offset < frame.length && frame[offset] !== 0x00) offset++;
            offset++;

            // Extract comment bytes
            let commentBytes = frame.slice(offset);

            let end = 0;
            while (end < commentBytes.length && commentBytes[end] !== 0x00) end++;

            commentBytes = commentBytes.slice(0, end);

            let text = decoder.decode(commentBytes).trim();

            return text.slice(0, text.length - 4);  // remove trailing TCON tag
        }

        pos += 10 + frameSize;
    }

    return null;
}

function Mp3CommentReader({ url }) {
    const [lines, setLines] = useState([]);

    useEffect(() => {
        if (!url) return;

        (async () => {
            try {
                // Read first 64 KB (more than enough for ID3v2)
                const bytes = await fetchRange(url, 0, 65535);
                const comment = parseID3v2Comment(bytes) || "";

                if (process.env.NODE_ENV === "development") {
                    console.log("MP3 metadata:", comment);
                }

                const commentLines = comment ? comment.split('\n').slice(1) : [];
                setLines(commentLines);
            } catch (err) {
                console.error("Failed to read MP3 COMMENT tag", err);
            }
        })();
    }, [url]);

    return (
        <div>
            {lines.map((line, i) => <p key={i}>{line}</p>)}
        </div>
    );
}

export default Mp3CommentReader;